<template>
  <div :class="'patients-block ' + 'patients'" style="position: relative;">
    <preloader :visible="isLoading" />
    <alert-message :message="message" />
    <div class="modal" id="documents-modal" :style="{ 'display': isDocumentsModal ? 'block' : 'none' }">
      <div class="modal-dialog" style="z-index: 2000; width: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" aria-hidden="true" v-on:click="closeDocumentsModal">×</button>
            <h4 class="modal-title">Documents</h4>
          </div>
          <div class="modal-body">
            <table class="table table-hover nowrap margin-bottom-0 custom-table-modifier width-full" data-form="prModal" v-if="documentItems">
              <thead><tr>
                <th>Created</th>
                <th>Technician</th>
                <th>Name</th>
                <th>Customers</th>
              </tr></thead>
              <tbody id="documents-table-body">
              <tr v-for="(document, index) in documentItems" :key="index">
                <td>{{ document.created_at }}</td>
                <td>{{ document.user.name }}</td>
                <td><a :href="`/document/${document.id}/download`">{{ document.source_name }}</a> </td>
                <td><div v-if="canGroups">
                    <div v-html="document.all_customers" class="table-span-block"></div>
                    <div v-html="document.all_groups" class="table-span-block"></div>
                </div></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div :class="{ 'modal-backdrop in': isDocumentsModal }" v-on:click="closeDocumentsModal"></div>
    </div>

    <table class="table table-hover nowrap margin-bottom-0 width-full" data-form="prModal" v-if="services && services.length > 0">
      <thead><tr>
        <th>Date</th>
        <th>Service</th>
        <th>Request</th>
        <th>Documents</th>
        <th>Actions</th>
      </tr></thead>
      <tbody id="services-table-body">
      <tr v-for="(service, index) in services" :key="index">
        <td>{{ momentVue(service.starts_at).format(dateFormat) }} - {{ momentVue(service.finishes_at).format(dateFormat) }}</td>
        <td class="ignore-custom-table-modifier">
          <div v-tooltip.top-center="getServiceName(service)" class="td-with-tooltip"><a :href="'/service/' + service.id">{{ getServiceName(service) }}</a></div>
        </td>
        <td><div v-if="service.patient_request">
          <a class="pr-modal" @click="showEnrollmentDetails(service.patient_request)" style="cursor: pointer">{{ momentVue(service.patient_request.created_at).format(dateFormat) }}</a>
        </div></td>
        <td><button type="button" @click="showDocumentsModal(service.documents)" class="btn btn-sm btn-success" id="documents-view-btn"
                  v-if="service.documents && service.documents.length > 0"><i class="icmn-eye" aria-hidden="true"></i></button>
        </td>
        <td><a class="mr-2 mb-2 btn btn-sm btn-danger" v-on:click="tryDelete(service.id)" >X</a></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";
import AlertMessage from "./blocks/alert-message";
export default {
  components: { AlertMessage, Preloader },
  props: {
    id: {
      type: Number
    },
    route: {
      type: String
    },
    dateFormat: {
      type: String,
      default: 'MM-DD-YYYY'
    },
    appUrl: {
      type: String,
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canGroups: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: '',
      isLoading: false,
      isDocumentsModal: false,
      documentItems: null,
      services: null
    }
  },
  methods: {
    momentVue(...args) {
      return moment(...args);
    },
    momentDiff(timestamp) {
      return moment().diff(moment.utc(timestamp), 'minutes');
    },
    momentFromNow(timestamp) {
      return moment.utc(timestamp).fromNow();
    },
    onLoading(e) {
      this.isLoading = true;
    },
    onLoaded(e) {
      this.isLoading = false;
    },

    getServiceName(service) {
      if (service.name) {
        return service.name
      } else if (service.patient) {
        return `${service.patient.name} - ${service.patient.phones[0]}`
      } else {
        return `#${service.id}`
      }
    },

    fetchData() {
      this.isLoading = true;
      axios.get(`/patient/${this.id}/patient-history`).then(res => {
        this.services = res.data;
        this.isLoading = false;
      }).catch(e => {
        console.log(e);
        this.toast('Error getting patient history', 'error');
      });
    },
    fetchServicesData(data) {
      this.isLoading = true;
      const url = `/patient/patient-history/services?service_ids=${data}`;
      axios.get(url).then(res => {
        this.services = res.data;
        this.isLoading = false;
      }).catch(e => {
        console.log(e);
        this.toast('Error getting patient services', 'error');
      });
    },
    getPatientRequestNotes(request) {
      let result = `From ${this.momentVue(request.created_at).format(this.dateFormat)}&#013;&#010;`
          + `Monitor SN: ${request.monitoring_serial_number}&#013;&#010;`
          + 'Monitoring: ' + this.momentVue(request.monitoring_starts_at).format(this.dateFormat) + ' - ' + this.momentVue(request.monitoring_finishes_at).format(this.dateFormat) + '&#013;&#010;';
      if (request.primary_type) {
        result += `Primary: ${request.primary_type} for ${request.primary_days} with '${request.primary_code}'&#013;&#010;`;
        if (request.extended_type) {
          result += `Extended: ${request.extended_type} for ${request.extended_days} with '${request.extended_code}'&#013;&#010;`;
        }
      }
      return result
          + 'Requesting Physician: ' + request.doctor_first_name + ' ' + request.doctor_last_name + '&#013;&#010;'
          + ' # Phone: ' + request.doctor_phone + '&#013;&#010;'
          + 'Primary Physician: ' + request.primary_doctor_name + '&#013;&#010;'
          + ' # Phone: ' + request.primary_doctor_phone + '&#013;&#010;'
          + ' # Notes: ' + request.primary_doctor_notes + '&#013;&#010;'
          + 'Patient Notes: ' + request.notes + '&#013;&#010;'
          + 'Pacemaker: ' + (request.is_pacemaker ? 'Yes' : 'No') + '&#013;&#010;'
          + 'Next of Kin Name: ' + request.kin_first_name + ' ' + request.kin_last_name + '&#013;&#010;'
          + ' # Phone: ' + request.kin_phone + '&#013;&#010;'
          + ' # Relationship: ' + request.kin_personal_relationship + '&#013;&#010;'
          + 'Primary Insurance Name: ' + request.insurance_name + '&#013;&#010;'
          + ' # Address: ' + request.insurance_address + '&#013;&#010;'
          + ' # Referral: ' + request.insurance_referral + '&#013;&#010;'
          +' # ID: ' + request.insurance_id + '&#013;&#010;'
          + ' # Group: ' + request.insurance_group + '&#013;&#010;';
    },

    tryDelete(id) {
      this.$swal.fire({
        text: 'Are you sure?',
        icon: 'warning',
        confirmButtonText: 'Delete',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteRecord(id);
        }
      });
    },
    deleteRecord(id) {
      const services = this.services;
      let delete_index = undefined;
      for (const i in services) {
        if (services[i].id === id) {
          delete_index = i;
          break
        }
      }
      if (delete_index && delete_index >= 0) {
        services.splice(delete_index, 1)
        this.services = services;
      }
    },

    showEnrollmentDetails(request) {
      this.$swal.fire({
        title: 'Enrollment',
        html: '<pre>' + this.getPatientRequestNotes(request) + '</pre>',
        showCloseButton: true,
        showCancelButton: false,
      });
    },

    showDocumentsModal(documents) {
      this.isDocumentsModal = true;
      this.documentItems = documents;
    },
    closeDocumentsModal() {
      this.isDocumentsModal = false;
      this.documentItems = null;
    },

    toast(message, type) {
      const self = this.$swal;
      self.fire({
        text: message,
        icon: type || 'success',
        toast: true,
        showConfirmButton: false,
        position: 'top-end',
        timer: 1500,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', self.stopTimer)
          toast.addEventListener('mouseleave', self.resumeTimer)
        }
      });
    }
  },
  mounted() {
    window.bus.$on('UPDATE_PATIENT_HISTORY', this.fetchServicesData);
  }
}
</script>

<style>
.patients-block .actions-bts > a {
  margin: 2px 0;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip:focus {
  outline: none;
}

.popover {
  max-width: unset;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
  max-width: unset;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0,0,0, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #c8cfdb;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
.tooltip-custom-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2px 0;
  min-width: 200px;
}

.tooltip-custom-row .btn {
  margin-left: 5px;
}

.VueTables__limit {
  display: none;
}
</style>
